import React, { useState } from "react";
import './app.css';

export default function Apps(props) {

    function shoot(e) {
      var el = document.getElementById('op1');
      el.classList.remove('_1fqn0');
      var el2 = document.getElementById('op2');
      el2.classList.remove('_1fqn0');
      e.currentTarget.classList.toggle('_1fqn0')
      }

      function shoot1(e) {

        var el = document.getElementById('op');
        el.classList.remove('_1fqn0');
        var el2 = document.getElementById('op2');
        el2.classList.remove('_1fqn0');
        e.currentTarget.classList.toggle('_1fqn0')

     }
        function shoot2(e) {

            var el = document.getElementById('op1');
            el.classList.remove('_1fqn0');
            var el2 = document.getElementById('op');
            el2.classList.remove('_1fqn0');
            e.currentTarget.classList.toggle('_1fqn0')
            
            }
     function openmenu(e){
        // alert(222); 
         var el = document.getElementById('sidebarmenu');
         el.classList.toggle('opensidebar')
         var el2 = document.getElementsByClassName('_2THv1')[0]
         el2.classList.toggle('_8Oh3q') 
         var el21 = document.getElementsByClassName('_2Ei7e')[0]
         el21.classList.toggle('addtra')
     }
     
     function openconfig(e){
        var el2 = document.getElementsByClassName('configdrop')[0]
        el2.classList.toggle('show') 
        var el2 = document.getElementsByClassName('menuwadd')[0]
        el2.classList.toggle('dropconfigsub1') 
     }

     function navclick(e){
        
       var str = e.currentTarget.href;
       var res = str.split("#");
       var el2 = document.getElementsByClassName('maintab')[0]
       el2.classList.remove('nonediv')
        el2.classList.add('nonediv')
       
        var btnContainer = document.getElementById("card-header-pills");
        var btns = btnContainer.getElementsByClassName("nav-link");
        var btnContainer1 = document.getElementById("maintab");
        var btns1 = btnContainer1.getElementsByClassName("opentab");

    for (var i = 0; i < btns1.length; i++) {
        btns1[i].classList.remove("opentab");

    }
    for (var i = 0; i < btns.length; i++) {
        
        btns[i].classList.remove("active");
        
    
    }
  //alert(res[1]);
        var el = document.getElementById(res[1])
        el.classList.add('opentab')
        //navRef.current.classList.remove("active");
         e.currentTarget.classList.add('active')
     }
  
  return (
    <>
   
         <div class="_2nR6t upsignal">
                <div class="_2NS96">
                    <div class="_1fhil"></div>
                    <div class="_1RiPb"></div>
                </div>
                <div class="_2Qk4f">
                   
                    <div class="_2RHK6 _14wL6">
                        <div class="_2kHSr _2jBtQ _3z7OM _3Uosj _1K3hm" id="sidebarmenu" >
                            <div class="_3hcLl" >
                                <div class="_1jc8P">
                                    <div class="_3iyER">
                                        <div class="ljYKJ logoname">
                                           TBD
                                        </div>
                                        <div class="_13epd">
                                            <div class="QPQ6k">
                                                <div class="_29AwW">
                                                    <div class="_ewpg _1fqn0" id="op" onClick={shoot}>
                                                        <div class="ORPh0">
                                                            <div class="_1ObBr">
                                                                <svg width="24" height="24" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        fill-rule="evenodd"
                                                                        clip-rule="evenodd"
                                                                        d="M64 8L112 16L106.663 74.704C105.029 92.681 93.4472 108.221 76.6872 114.925L64 120L51.3128 114.925C34.5528 108.221 22.971 92.681 21.3367 74.704L16 16L64 8ZM24.6394 22.6705L29.3039 73.9797C30.6658 88.9605 40.3173 101.911 54.284 107.497L64 111.384L73.716 107.497C87.6827 101.911 97.3342 88.9605 98.6961 73.9797L103.361 22.6705L64 16.1103L24.6394 22.6705ZM32 30L64 24V104C49.3441 99.1147 38.8148 86.2221 36.9558 70.8856L32 30Z"
                                                                    ></path>
                                                                </svg>
                                                            </div>
                                                            <div class="W5zWj">
                                                                <div class="wyuh-">
                                                                    <h3 class="_1VrMK">DNS</h3> 
                                                                    <svg  width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="UyUWa">
                                                                        <path
                                                                            d="M10.9996 7.50031C10.6104 7.88958 9.97933 7.88992 9.58963 7.50107L5.70502 3.62492L1.8204 7.50108C1.4307 7.88992 0.799674 7.88958 0.410401 7.50031C0.0208283 7.11073 0.0208285 6.47911 0.410402 6.08954L5.70502 0.794922L10.9996 6.08954C11.3892 6.47911 11.3892 7.11073 10.9996 7.50031Z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                                <p class="_18u0w">Secure your digital life on all devices.</p>
                                                            </div>
                                                        </div>
                                                        <div class="_2zFLh submenu firstsub">
                                                <a class="_3KvtS _2zJ8_ _3cnB6"  href="/trial/setup">Reports</a>
                                                <a class="_3KvtS _2zJ8_  "  href="security">Analytics</a>
                                                        
                                                    </div>
                                                        <div class="_3al5t"></div>
                                                    </div>
                                                    <div class="_ewpg" id="op1" onClick={shoot1}>
    <div class="ORPh0">
        <div class="_1ObBr">
            <svg width="24" height="24" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M64 8L112 16L106.663 74.704C105.029 92.681 93.4472 108.221 76.6872 114.925L64 120L51.3128 114.925C34.5528 108.221 22.971 92.681 21.3367 74.704L16 16L64 8ZM24.6394 22.6705L29.3039 73.9797C30.6658 88.9605 40.3173 101.911 54.284 107.497L64 111.384L73.716 107.497C87.6827 101.911 97.3342 88.9605 98.6961 73.9797L103.361 22.6705L64 16.1103L24.6394 22.6705ZM32 30L64 24V104C49.3441 99.1147 38.8148 86.2221 36.9558 70.8856L32 30Z"
                ></path>
            </svg>
        </div>
        <div class="W5zWj">
            <div class="wyuh-">
                <h3 class="_1VrMK">Tor</h3>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="UyUWa">
                    <path
                        d="M10.9996 7.50031C10.6104 7.88958 9.97933 7.88992 9.58963 7.50107L5.70502 3.62492L1.8204 7.50108C1.4307 7.88992 0.799674 7.88958 0.410401 7.50031C0.0208283 7.11073 0.0208285 6.47911 0.410402 6.08954L5.70502 0.794922L10.9996 6.08954C11.3892 6.47911 11.3892 7.11073 10.9996 7.50031Z"
                    ></path>
                </svg>
            </div>
            <p class="_18u0w">Manage access to the Tor Network.</p>
        </div>
    </div>
    <div class="_2zFLh submenu">
                                                <a class="_3KvtS _2zJ8_"  href="#">Setup</a>
                                                <a class="_3KvtS _2zJ8_ "  href="#">Bridges</a>
                                                        
                                                    </div>
    <div class="_3al5t"></div>
</div>

    
                                                    
                                                    <div class="_ewpg" id="op2" onClick={shoot2}>
                                                        <div class="ORPh0">
                                                            <div class="_1ObBr">
                                                                <svg width="24" height="24" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        fill-rule="evenodd"
                                                                        clip-rule="evenodd"
                                                                        d="M64 8C94.9279 8 120 33.0721 120 64C120 94.9279 94.9279 120 64 120C33.0721 120 8 94.9279 8 64C8 33.0721 33.0721 8 64 8ZM64 16C37.4903 16 16 37.4903 16 64C16 90.5097 37.4903 112 64 112C90.5097 112 112 90.5097 112 64C112 37.4903 90.5097 16 64 16ZM78.5743 35.2112C75.545 31.7513 70.6419 30 63.9998 30C57.3577 30 52.4546 31.7513 49.4253 35.2096C46.3627 38.7031 46.2269 42.8501 46.2968 44.3793L46.3158 44.6893L46.3302 44.8526V52.5272L46.1784 52.7111C45.34 53.768 44.8723 55.0764 44.8723 56.4229V62.2525L44.8765 62.4781C44.941 64.2028 45.7422 65.7994 47.0748 66.8915C48.1945 71.2795 50.3103 74.7708 51.5572 76.5664L51.8575 76.9903L52.1587 77.3978V82.1568L52.1546 82.3312C52.0943 83.6048 51.376 84.7601 50.2488 85.3767L35.2522 91.4692L34.9421 91.6451C34.7357 91.767 34.53 91.8979 34.3244 92.0371L34.0436 92.2325L34 92.2711C41.4222 98.9417 53.2372 104 63.9998 104C74.7626 104 86.5779 98.9414 94 92.2705L93.9776 92.2512L93.796 92.4147C93.3128 92.0809 92.8262 91.7816 92.3282 91.5316L76.4112 85.5707L76.2575 85.4893C75.0987 84.8409 74.3862 83.6313 74.3862 82.2933V77.4307L74.5816 77.1857C74.8449 76.8507 75.1189 76.4832 75.4003 76.0872C77.2018 73.5416 78.6466 70.7099 79.7002 67.6627C81.7827 66.6728 83.1273 64.5975 83.1273 62.2541V56.4246L83.1224 56.1874C83.0679 54.8461 82.5526 53.5555 81.6693 52.5289V44.8543L81.6937 44.5479C81.7788 43.1753 81.757 38.8417 78.5743 35.2112Z"
                                                                    ></path>
                                                                </svg>
                                                            </div>
                                                            <div class="W5zWj">
                                                                <div class="wyuh-">
                                                                    <h3 class="_1VrMK">Account Settings</h3>
                                                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="UyUWa">
                                                                        <path
                                                                            d="M10.9996 7.50031C10.6104 7.88958 9.97933 7.88992 9.58963 7.50107L5.70502 3.62492L1.8204 7.50108C1.4307 7.88992 0.799674 7.88958 0.410401 7.50031C0.0208283 7.11073 0.0208285 6.47911 0.410402 6.08954L5.70502 0.794922L10.9996 6.08954C11.3892 6.47911 11.3892 7.11073 10.9996 7.50031Z"
                                                                        ></path>
                                                                    </svg>
                                                                </div>
                                                                <p class="_18u0w">Settings and more.</p>
                                                            </div>
                                                        </div>
                                                        <div class="_2zFLh submenu">
                                            <a class="_3KvtS _2zJ8_ "  href="/trial/account">Account settings</a>
                                                <a class="_3KvtS _2zJ8_ "  href="#">Subscription</a>
                                                        
                                                    </div>
                                                        <div class="_3al5t"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="_29JGy">
                        <div data-test="header" class="_3dJ9M">
				    																								<div class="_3daw4">
        <button type="button" tabindex="0" class="_3-mad _2Ei7e" onClick={openmenu}>
            <div class="_2THv1">
                <div class="_2jRz9"><div></div></div>
            </div>
        </button>

      

    </div>
				    																																																																												<div class="_3VCAu">
        <a href="#" class="XwTk5 _3-mad">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="rJl7m">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17ZM4 12C4 7.58999 7.59 3.99999 12 3.99999C16.41 3.99999 20 7.58999 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12ZM10 10H8C8 7.79 9.79 6 12 6C14.21 6 16 7.79 16 10C16 11.2829 15.21 11.9733 14.4408 12.6455C13.711 13.2833 13 13.9046 13 15H11C11 13.1787 11.9421 12.4566 12.7704 11.8217C13.4202 11.3236 14 10.8792 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10Z"
                ></path>
            </svg>
        </a>

        <div class="dropdown configdrop">
        <button type="button" class="notranslate dropdown-toggle btn btn-light" onClick={openconfig}>Andrew</button>
        <div class="dropdown-menu menuwadd" >
        <a href="#" class="text-primary dropdown-item" role="button"> Edit Profile</a>
            <div class="dropdown-divider" role="separator"></div>
            <a href="#" class="text-primary dropdown-item" role="button"> Settings</a>
            <div class="dropdown-divider" role="separator"></div>
            <a href="#" class="text-primary dropdown-item" role="button"> Create Company</a>
            <div class="dropdown-divider" role="separator"></div>
            <a href="#" class="text-primary dropdown-item" role="button">Log Out</a>
        </div>
    </div>

    
       
    </div>
				</div>
                <div data-test="content-drawer" class="_2RHK6 _3UaLE">
<div class="QPQ6k">
<div class="_16L5c">
<div><h2 class="_1kk-Y">Create Report  <button class="msetupb">Create Report</button></h2>

<div class="_1panS">
    
<a href="#" class="_3KvtS _1JZmm" data-test="apps-linux">
        <div class="_2dOgn Ni3Te">
            <div class="_2dVdw" data-test="menu-list-item">
                
                <div class="_3KE3M">
                    <div class="_3twFQ">Linux</div>
                    <div class="_3oQis">Works on Ubuntu, Debian.</div>
                </div>
              
            </div>
        </div>
    </a> 
    <a href="#" class="_3KvtS _1JZmm" data-test="apps-linux">
        <div class="_2dOgn Ni3Te">
            <div class="_2dVdw" data-test="menu-list-item">
                
                <div class="_3KE3M">
                    <div class="_3twFQ">Linux</div>
                    <div class="_3oQis">Works on Ubuntu, Debian.</div>
                </div>
               
            </div>
        </div>
    </a>
</div>

<div class="_1panS">
    <h2 class="_1kk-Y">Active Reports</h2>
    <a href="#" class="_3KvtS _1JZmm" target="_blank" data-test="apps-chrome">
        <div class="_2dOgn Ni3Te">
            <div class="_2dVdw" data-test="menu-list-item">
                

                <div class="_3KE3M">
                    <div class="_3twFQ">Chrome</div>
                    <div class="_3oQis">Works on Chrome 80 and later.</div>
                </div>

                
            </div>
        </div>
    </a>

    <a href="#" class="_3KvtS _1JZmm" target="_blank" data-test="apps-firefox">
        <div class="_2dOgn Ni3Te">
            <div class="_2dVdw" data-test="menu-list-item">
                

                <div class="_3KE3M">
                    <div class="_3twFQ">Firefox</div>
                    <div class="_3oQis">Works on Firefox 68 and later.</div>
                </div>

               
            </div>
        </div>
    </a>
</div>

<div class="row">
    <div class="mb-4 col">
        <div id="setup-guide" class="card">
            <div class="list-group list-group-flush">
                <div class="py-3 list-group-item">
                    <h5>Setup Guide</h5>
                    <div class="pro1">Follow the instructions below to set up TBD on your device, browser or router.</div>
                    <div class="mx-0 mt-4 notranslate nav card-header-pills nav-pills" id="card-header-pills">
                        <div class="nav-item">
                            <a href="#android" data-rb-event-key="#android" class="nav-link" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="android"
                                    class="svg-inline--fa fa-android fa-w-18 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                    
                                >
                                    <path
                                        fill="currentColor"
                                        d="M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                                    ></path>
                                </svg>
                                <span>Android</span>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a href="#ios" data-rb-event-key="#ios" class="nav-link" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="apple"
                                    class="svg-inline--fa fa-apple fa-w-12 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 384 512"
                                    
                                >
                                    <path
                                        fill="currentColor"
                                        d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                                    ></path>
                                </svg>
                                <span>iOS</span>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a href="#windows" data-rb-event-key="#windows" class="nav-link active" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="windows"
                                    class="svg-inline--fa fa-windows fa-w-14 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    
                                >
                                    <path fill="currentColor" d="M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"></path>
                                </svg>
                                <span>Windows</span>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a href="#macos" data-rb-event-key="#macos" class="nav-link" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="apple"
                                    class="svg-inline--fa fa-apple fa-w-12 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 384 512"
                                   
                                >
                                    <path
                                        fill="currentColor"
                                        d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                                    ></path>
                                </svg>
                                <span>macOS</span>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a href="#linux" data-rb-event-key="#linux" class="nav-link" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="linux"
                                    class="svg-inline--fa fa-linux fa-w-14 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    
                                >
                                    <path
                                        fill="currentColor"
                                        d="M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                                    ></path>
                                </svg>
                                <span>Linux</span>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a href="#chromeos" data-rb-event-key="#chromeos" class="nav-link" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fab"
                                    data-icon="chrome"
                                    class="svg-inline--fa fa-chrome fa-w-16 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 496 512"
                                    
                                >
                                    <path
                                        fill="currentColor"
                                        d="M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"
                                    ></path>
                                </svg>
                                <span>Chrome OS</span>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a href="#browsers" data-rb-event-key="#browsers" class="nav-link" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="window-maximize"
                                    class="svg-inline--fa fa-window-maximize fa-w-16 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    
                                >
                                    <path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"></path>
                                </svg>
                                <span>Browsers</span>
                            </a>
                        </div>
                        <div class="nav-item">
                            <a href="#routers" data-rb-event-key="#routers" class="nav-link" onClick={navclick}>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="home"
                                    class="svg-inline--fa fa-home fa-w-18 marright"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                   
                                >
                                    <path
                                        fill="currentColor"
                                        d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                                    ></path>
                                </svg>
                                <span>Routers</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="maintab" id="maintab">
                <div id="windows" class="setuptabmain opentab">
                <div class="py-5 px-md-5 list-group-item">
                    <div class="d-inline-block mb-2 bhq">Recommended</div>
                    <div class="kal">TBD for Windows</div>
                    <div class="mt-4">
                        <div class="my-2">1. Download the installer <a href="https://TBD.io/download/windows/stable">here</a>.</div>
                        <div class="my-2">2. After installing, right-click on TBD icon in the Systray then open the Settings. Set <span class="notranslate fweifght">a821d5</span> as Configuration ID.</div>
                        <div class="my-2">3. Right-click on TBD icon in the Systray, then click on Enable.</div>
                    </div>
                </div>
                <div class="py-5 px-md-5 list-group-item">
                    <div class="lsw">
                        <div class="d-inline-block laqp">Or</div>
                    </div>
                    <div class="kal">IPv6</div>
                    <div class="ldwe">
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="check-circle"
                            class="svg-inline--fa fa-check-circle fa-w-16"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            class="lsx"
                        >
                            <path
                                fill="currentColor"
                                d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                            ></path>
                        </svg>
                        <span>Your network supports IPv6</span>
                    </div>
                    <div class="mt-4">
                        <div class="my-2">1. Click on the Start menu, then click on Control Panel.</div>
                        <div class="my-2">2. Click on Network and Internet, then Network and Sharing Center.</div>
                        <div class="my-2">3. Click on Change Adapter Settings.</div>
                        <div class="my-2">4. Right click on the Wi-Fi network you are connected to, then click Properties.</div>
                        <div class="my-2">5. Select Internet Protocol Version 6.</div>
                        <div class="my-2">6. Click Properties.</div>
                        <div class="my-2">7. Click Use The Following DNS Server Addresses.</div>
                        <div class="my-2">
                            8. Replace the current addresses (if any) with <span class="notranslate fweifght">2a07:a8c0::a8:21d5</span> and <span class="notranslate fweifght">2a07:a8c1::a8:21d5</span>.
                        </div>
                        <div class="my-2">9. Click OK, then Close. You may need to restart your browser.</div>
                    </div>
                </div>
                <div class="py-5 px-md-5 list-group-item">
                    <div class="lsw">
                        <div class="d-inline-block laqp">Or</div>
                    </div>
                    <div class="kal">IPv4 (with Linked IP)</div>
                    <div class="mt-4">
                        <div class="my-2">1. Click on the Start menu, then click on Control Panel.</div>
                        <div class="my-2">2. Click on Network and Internet, then Network and Sharing Center.</div>
                        <div class="my-2">3. Click on Change Adapter Settings.</div>
                        <div class="my-2">4. Right click on the Wi-Fi network you are connected to, then click Properties.</div>
                        <div class="my-2">5. Select Internet Protocol Version 4.</div>
                        <div class="my-2">6. Click Properties.</div>
                        <div class="my-2">7. Click Use The Following DNS Server Addresses.</div>
                        <div class="my-2">
                            8. Replace the current addresses (if any) with <span class="notranslate fweifght" >45.90.28.55</span> and <span class="notranslate fweifght">45.90.30.55</span>.
                        </div>
                        <div class="my-2">9. Click OK, then Close. You may need to restart your browser.</div>
                    </div>
                </div>
                <div class="py-5 px-md-5 list-group-item">
                    <div class="lsw">
                        <div class="d-inline-block laqp">Or</div>
                    </div>
                    <div class="d-inline-block mb-2 kalajj">Advanced</div>
                    <div class="notranslate kal">YogaDNS</div>
                    <div class="mt-4">
                        <div class="my-2">1. Install YogaDNS from <a class="notranslate" href="https://yogadns.com">https://yogadns.com</a>.</div>
                        <div class="my-2">
                            2. Follow the instructions for TBD at <a class="notranslate" href="https://yogadns.com/docs/TBD">https://yogadns.com/docs/TBD</a> and use
                            <span class="notranslate fweifght" >a821d5</span> as Configuration ID.
                        </div>
                    </div>
                </div>
            </div> 
             
            <div id="android" class="setuptabmain">
            <div class="py-5 px-md-5 list-group-item">
    <div class="d-inline-block mb-2  bhq" >Recommended</div>
    <div class="kal" >Private DNS</div>
    <div class="klos">Android 9 or higher</div>
    <div class="mt-4">
        <div class="my-2">1. Go to Settings → Network &amp; internet → Advanced → Private DNS.</div>
        <div class="my-2">2. Select the Private DNS provider hostname option.</div>
        <div class="my-2">3. Enter <span class="notranslate fweifght">a821d5.dns.TBD.io</span> and hit Save.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="d-inline-block mb-2 bhq" >Recommended</div>
    <div class="kal">TBD for Android</div>
    <div class="mt-4">
        <a href="https://play.google.com/store/apps/details?id=io.TBD.TBD"><img alt="" height="46" src="/static/media/play-store.35833df5.svg" /></a>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Install our official app from the Play Store.</div>
        <div class="my-2">2. In the TBD app, enter <span class="notranslate fweifght" >a821d5</span> in Settings → Configuration ID, then connect.</div>
    </div>
</div>



<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp">Or</div>
    </div>
    <div class="kal">IPv6</div>
    <div class="ldwe">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times-circle"
            class="svg-inline--fa fa-times-circle fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
           
        >
            <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
            ></path>
        </svg>
        <span>Your network does not support IPv6</span>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Go to Settings → Wi-Fi.</div>
        <div class="my-2">2. Long-press the network you are connected to then tap Modify Network.</div>
        <div class="my-2">3. On some devices, you may need to check the box for Advanced to see further settings. To adjust your DNS settings, you will need to switch the IP settings from DHCP to Static.</div>
        <div class="my-2">4. Enter <span class="notranslate fweifght" >2a07:a8c0::a8:21d5</span> for DNS 1 and <span class="notranslate fweifght" >2a07:a8c1::a8:21d5</span> for DNS 2.</div>
    </div>
</div>


<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal">IPv4 (with Linked IP)</div>
    <div class="mt-4">
        <div class="my-2">1. Go to Settings → Wi-Fi.</div>
        <div class="my-2">2. Long-press the network you are connected to then tap Modify Network.</div>
        <div class="my-2">3. On some devices, you may need to check the box for Advanced to see further settings. To adjust your DNS settings, you will need to switch the IP settings from DHCP to Static.</div>
        <div class="my-2">4. Enter <span class="notranslate fweifght">45.90.28.55</span> for DNS 1 and <span class="notranslate fweifght" >45.90.30.55</span> for DNS 2.</div>
    </div>
</div>




</div>

<div id="ios" class="setuptabmain">
<div class="py-5 px-md-5 list-group-item">
    <div class="d-inline-block mb-2 bhq">Recommended</div>
    <div class="kal">TBD for iOS</div>
    <div class="mt-4">
        <a href="#"><img alt="" height="46" src="/assets/images/app-store.efb98402.svg" /></a>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Install our official app from the App Store.</div>
        <div class="my-2">2. Open the app then go to Settings and toggle "Use Custom Configuration". Enter <span class="notranslate fweifght">a821d5</span> as Configuration ID.</div>
        <div class="my-2">3. Enable TBD.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp">Or</div>
    </div>
    <div class="d-inline-block mb-2 kalajj">Advanced</div>
    <div class="kal ">Configuration Profile</div>
    <div class="klos">iOS 14 or higher</div>
    <div class="mt-4">
        <div class="my-2">Use our Apple Configuration Profile Generator available at <a href="https://apple.TBD.io/?configuration=a821d5">apple.TBD.io</a>.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal">IPv6</div>
    <div class="ldwe">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times-circle"
            class="svg-inline--fa fa-times-circle fa-w-16 jrw"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            
        >
            <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
            ></path>
        </svg>
        <span>Your network does not support IPv6</span>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Open the Settings app, then go to Wi-Fi.</div>
        <div class="my-2">2. Tap on the ⓘ icon on the right-hand side of the Wi-Fi network of your choice.</div>
        <div class="my-2">3. In the DNS section, go to Configure DNS.</div>
        <div class="my-2">4. Select Manual.</div>
        <div class="my-2">
            5. In the DNS SERVERS list, remove all addresses (if any) then add <span class="notranslate fweifght" >2a07:a8c0::a8:21d5</span> and
            <span class="notranslate fweifght" >2a07:a8c1::a8:21d5</span>.
        </div>
        <div class="my-2">6. Tap Save.</div>
    </div>
</div>


<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal" >IPv4 (with Linked IP)</div>
    <div class="mt-4">
        <div class="my-2">1. Open the Settings app, then go to Wi-Fi.</div>
        <div class="my-2">2. Tap on the ⓘ icon on the right-hand side of the Wi-Fi network of your choice.</div>
        <div class="my-2">3. In the DNS section, go to Configure DNS.</div>
        <div class="my-2">4. Select Manual.</div>
        <div class="my-2">
            5. In the DNS SERVERS list, remove all addresses (if any) then add <span class="notranslate fweifght" >45.90.28.55</span> and <span class="notranslate fweifght" >45.90.30.55</span>.
        </div>
        <div class="my-2">6. Tap Save.</div>
    </div>
</div>

</div>


<div id="macos" class="setuptabmain">

<div class="py-5 px-md-5 list-group-item">
    <div class="d-inline-block mb-2 bhq" >Recommended</div>
    <div class="kal" >TBD for macOS</div>
    <div class="mt-4">
        <a href="#"><img alt="" height="46" src="/assets/images/mac-app-store.ab8f4d0f.svg" /></a>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Install our official app from the Mac App Store.</div>
        <div class="my-2">2. Click on Preferences in the app status bar menu and go to the Configuration tab.</div>
        <div class="my-2">3. Check "Use Custom Configuration" and enter <span class="notranslate fweifght" >a821d5</span> as Configuration ID.</div>
        <div class="my-2">4. Enable TBD.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw" >
        <div class="d-inline-block laqp">Or</div>
    </div>
    <div class="d-inline-block mb-2 kalajj" >Advanced</div>
    <div  class="kal ">Configuration Profile</div>
    <div class="klos">macOS Big Sur or higher</div>
    <div class="mt-4">
        <div class="my-2">Use our Apple Configuration Profile Generator available at <a href="#">apple.TBD.io</a>.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal">IPv6</div>
    <div class="ldwe">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times-circle"
            class="svg-inline--fa fa-times-circle fa-w-16 jrw"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            
        >
            <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
            ></path>
        </svg>
        <span>Your network does not support IPv6</span>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Open System Preferences, then click on Network.</div>
        <div class="my-2">2. Select the network you are connected to, then click on the Advanced button.</div>
        <div class="my-2">3. Go to the DNS section.</div>
        <div class="my-2">
            4. In the DNS Servers list, remove all addresses (if any) then add <span class="notranslate fweifght" >2a07:a8c0::a8:21d5</span> and
            <span class="notranslate fweifght" >2a07:a8c1::a8:21d5</span>.
        </div>
        <div class="my-2">5. Click OK, then click Apply.</div>
    </div>
</div>


<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal" >IPv4 (with Linked IP)</div>
    <div class="mt-4">
        <div class="my-2">1. Open System Preferences, then click on Network.</div>
        <div class="my-2">2. Select the network you are connected to, then click on the Advanced button.</div>
        <div class="my-2">3. Go to the DNS section.</div>
        <div class="my-2">
            4. In the DNS Servers list, remove all addresses (if any) then add <span class="notranslate fweifght" >45.90.28.55</span> and <span class="notranslate fweifght" >45.90.30.55</span>.
        </div>
        <div class="my-2">5. Click OK, then click Apply.</div>
    </div>
</div>



</div>
            
<div id="linux" class="setuptabmain">

<div class="py-5 px-md-5 list-group-item">
    <div class="d-inline-block mb-2 bhq" >Recommended</div>
    <div class="kal">TBD Command-Line Client</div>
    <div class="mt-4">
        <div class="my-2">
            1. Run the following command:
            <span class="notranslate loaq">sh -c "$(curl -sL https://tbd.io/install)"</span>
        </div>
        <div class="my-2">2. Follow the instructions.</div>
    </div>
    <div class="mt-4">
        <div class="my-2">Head over to our open-source repository at <a href="#">https://github.com/tbd/tbd/wiki</a> for manual installation instructions.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
      <div class="kal">IPv6</div>
    <div class="ldwe">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times-circle"
            class="svg-inline--fa fa-times-circle fa-w-16 jrw"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            
        >
            <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
            ></path>
        </svg>
        <span >Your network does not support IPv6</span>
    </div>
    <div class="mt-4">
        <div class="my-2">Change your DNS servers to <span class="notranslate fweifght">2a07:a8c0::a8:21d5</span> and <span class="notranslate fweifght">2a07:a8c1::a8:21d5</span>.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal" >IPv4 (with Linked IP)</div>
    <div class="mt-4">
        <div class="my-2">Change your DNS servers to <span class="notranslate fweifght" >45.90.28.55</span> and <span class="notranslate fweifght" >45.90.30.55</span>.</div>
    </div>
</div>


<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="notranslate kal">dnsmasq</div>
    <div class="mt-4">
        <div class="my-2">
            Use the following in <span class="notranslate">dnsmasq.conf</span>:
            <div class="mt-2 laqop">
                <div class="notranslate lanz">
                    no-resolv<br />
                    bogus-priv<br />
                    strict-order<br />
                    server=2a07:a8c1::<br />
                    server=45.90.30.0<br />
                    server=2a07:a8c0::<br />
                    server=45.90.28.0<br />
                    add-cpe-id=<b>a821d5</b>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="notranslate kal">Stubby</div>
    <div class="mt-4">
        <div class="my-2">
            Use the following in <span class="notranslate">stubby.yml</span>:
            <div class="mt-2 laqop" >
                <div class="notranslate lanz" >
                    round_robin_upstreams: 0<br />
                    upstream_recursive_servers:<br />
                    &nbsp;&nbsp;- address_data: 45.90.28.0<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;tls_auth_name: "<b>a821d5</b>.dns1.TBD.io"<br />
                    &nbsp;&nbsp;- address_data: 2a07:a8c0::0<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;tls_auth_name: "<b>a821d5</b>.dns1.TBD.io"<br />
                    &nbsp;&nbsp;- address_data: 45.90.30.0<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;tls_auth_name: "<b>a821d5</b>.dns2.TBD.io"<br />
                    &nbsp;&nbsp;- address_data: 2a07:a8c1::0<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;tls_auth_name: "<b>a821d5</b>.dns2.TBD.io"
                </div>
            </div>
        </div>
    </div>
    <div class="mt-4 asdlop">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="exclamation-triangle"
            class="svg-inline--fa fa-exclamation-triangle fa-w-18"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            
        >
            <path
                fill="currentColor"
                d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
            ></path>
        </svg>
        Make sure Stubby is linked with <span class="fweifght">OpenSSL 1.1.1 or higher</span> as previous versions will not work with TBD.
    </div>
</div>

</div>

<div id="chromeos" class="setuptabmain">

<div class="py-5 px-md-5 list-group-item">
    <div class="kal">TBD for Chrome OS</div>
    <div class="mt-4">
        <a href="#">
            <img
                alt=""
                height="60"
                src="data:image/png;base64,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"
            />
        </a>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Install our official Chrome extension from the Chrome Web Store.</div>
        <div class="my-2">2. In the Settings, enter <span class="notranslate fweifght" >a821d5 as Configuration ID, then connect. </span></div>
    </div>
</div>


<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp">Or</div>
    </div>
    <div class="kal">IPv6</div>
    <div class="ldwe">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times-circle"
            class="svg-inline--fa fa-times-circle fa-w-16 jrw"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
           
        >
            <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
            ></path>
        </svg>
        <span >Your network does not support IPv6</span>
    </div>
    <div class="mt-4">
        <div class="my-2">Change your DNS servers to <span class="notranslate fweifght" >2a07:a8c0::a8:21d5</span> and <span class="notranslate fweifght" >2a07:a8c1::a8:21d5</span>.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp">Or</div>
    </div>
    <div class="kal" >IPv4 (with Linked IP)</div>
    <div class="mt-4">
        <div class="my-2">Change your DNS servers to <span class="notranslate fweifght" >45.90.28.55</span> and <span class="notranslate fweifght" >45.90.30.55</span>.</div>
    </div>
</div>


</div>

<div id="browsers" class="setuptabmain">

<div class="py-5 px-md-5 list-group-item">
    <div class="d-flex align-items-center kal">
        <img class="iof" src="/assets/images/google-chrome.c4e2a064.svg" height="20" alt="" />
        <div>Google Chrome</div>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Go to Settings.</div>
        <div class="my-2">2. In the Privacy and security section, click on Security.</div>
        <div class="my-2">
            3. In the Advanced section, enable Use secure DNS.

            <div class="my-2">4. Select With: Custom, then enter <span class="notranslate fweifght" >https://dns.TBD.io/a821d5</span>.</div>
        </div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="d-flex align-items-center kal">
        <img class="iof" src="/assets/images/firefox.16821f55.svg" height="20" alt=""  />
        <div>Firefox</div>
    </div>
    <div class="klos">Windows, macOS and Linux only</div>
    <div class="mt-4">
        <div class="my-2">1. Open Preferences.</div>
        <div class="my-2">2. Scroll down to the Network Settings section and click on Settings.</div>
        <div class="my-2">3. Scroll down and check Enable DNS over HTTPS.</div>
        <div class="my-2">4. Select Custom, enter <span class="notranslate fweifght" > https://dns.TBD.io/a821d5</span> and click OK.</div>
        <div class="my-2">5. Enter "<span class="notranslate">about:config</span>" in the address bar (and click on I Accept the risk! if asked).</div>
        <div class="my-2">6. Set <span class="notranslate">network.trr.mode</span> to <span class="notranslate fweifght">3</span>.</div>
    </div>
</div>

</div>

<div id="routers" class="setuptabmain">

<div class="py-5 px-md-5 list-group-item">
    <div class="d-inline-block mb-2 bhq" >Recommended</div>
    <div class="kal" >TBD for Routers</div>
    <div class="klos" >Only works on routers that can run executables</div>
    <div class="mt-4">
        <div class="my-2">Head over to our open-source repository at <a href="https://github.com/TBD/TBD/wiki">https://github.com/TBD/TBD/wiki</a> for installation instructions.</div>
    </div>
</div>

<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal">IPv6</div>
    <div class="ldwe">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times-circle"
            class="svg-inline--fa fa-times-circle fa-w-16 jrw"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            
        >
            <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
            ></path>
        </svg>
        <span>Your network does not support IPv6</span>
    </div>
    <div class="mt-4">
        <div class="my-2">1. Open the preferences for your router. Usually you can access it from your browser via a URL (like http://192.168.0.1/ or http://192.168.1.1/).</div>
        <div class="my-2">2. Locate the DNS settings inside the interface.</div>
        <div class="my-2">3. Remove all addresses (if any) then add <span class="notranslate fweifght" >2a07:a8c0::a8:21d5</span> and <span class="notranslate fweifght" >2a07:a8c1::a8:21d5</span>.</div>
        <div class="my-2">4. Click Save (or similar).</div>
    </div>
    <div class="mt-4 asdlop">
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="exclamation-triangle"
            class="svg-inline--fa fa-exclamation-triangle fa-w-18"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            
        >
            <path
                fill="currentColor"
                d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
            ></path>
        </svg>
        Some routers may not support the IPv6 notation above. In that case, use <span class="notranslate fweifght" >2a07:a8c0:0000:0000:0000:0000:00a8:21d5</span> and
        <span class="notranslate fweifght">2a07:a8c1:0000:0000:0000:0000:00a8:21d5</span>.
    </div>
</div>


<div class="py-5 px-md-5 list-group-item">
    <div class="lsw">
        <div class="d-inline-block laqp" >Or</div>
    </div>
    <div class="kal">IPv4 (with Linked IP)</div>
    <div class="mt-4">
        <div class="my-2">1. Open the preferences for your router. Usually you can access it from your browser via a URL (like http://192.168.0.1/ or http://192.168.1.1/).</div>
        <div class="my-2">2. Locate the DNS settings inside the interface.</div>
        <div class="my-2">3. Remove all addresses (if any) then add <span class="notranslate fweifght" >45.90.28.55</span> and <span class="notranslate fweifght" >45.90.30.55</span>.</div>
        <div class="my-2">4. Click Save (or similar).</div>
    </div>
</div>


</div>

            </div>
            </div>
        </div>
    </div>
</div>

</div>
</div>
</div>
</div>

</div>
                    </div>
                </div>
                
            </div>
            
            <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog">
    
    <div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Add a blocklist</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
    </div>
    <div class="p-0 modal-body">
        <div class="list-group list-group-flush">
            <div class="list-group-item listitemg">
                <div class="d-lg-flex">
                    <div class="flex-grow-1">
                        <div class="notranslate koi">TBD Ads &amp; Trackers Blocklist</div>
                        <div class="mt-1 m12" >A comprehensive blocklist to block ads &amp; trackers in all countries. This is the recommended starter blocklist.</div>
                        <div class="mt-1 m123">
                            <div class="d-sm-inline mt-1 mt-sm-0">
                                <span class="op2" >65,389 entries</span><span class="op2"> • </span><span class="op2">Updated <time datetime="1600659128000">5 days ago</time></span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 my-lg-0 ml-lg-4">
                        <button type="button" class="btn btn-danger btn-sm ioe">Remove</button>
                    </div>
                </div>
            </div>
            <div class="list-group-item hgroup">
                <div class="d-lg-flex">
                    <div class="flex-grow-1">
                        <div class="notranslate koi" >Disconnect (Ads)</div>
                        <div class="mt-1 m12" >Free yourself from unwanted tracking. Enjoy a faster, safer internet.</div>
                        <div class="mt-1 m123">
                            <div class="d-sm-inline">
                                <a target="_blank" rel="noopener noreferrer" href="https://disconnect.me" class="notranslate wordbreak">disconnect.me</a><span class="d-none d-sm-inline op2" > • </span>
                            </div>
                            <div class="d-sm-inline mt-1 mt-sm-0">
                                <span class="op2">2,701 entries</span><span class="op2"> • </span><span class="op2">Updated <time datetime="1586487607000">6 months ago</time></span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 my-lg-0 ml-lg-4">
                        <button type="button" class="btn btn-primary btn-sm ioe" >Add</button>
                    </div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-lg-flex" >
                    <div class="flex-grow-1">
                        <div class="notranslate koi">AdGuard DNS filter</div>
                        <div class="mt-1 m12" >
                            A filter composed of several other filters (AdGuard Base filter, Social media filter, Tracking Protection filter, Mobile Ads filter, EasyList and EasyPrivacy) and simplified specifically to be better compatible
                            with DNS-level ad blocking.
                        </div>
                        <div class="mt-1 m123">
                            <div class="d-sm-inline">
                                <a target="_blank" rel="noopener noreferrer" href="https://github.com/AdguardTeam/AdguardSDNSFilter" class="notranslate wordbreak" >github.com/AdguardTeam/AdguardSDNSFilter</a>
                                <span class="d-none d-sm-inline op2" > • </span>
                            </div>
                            <div class="d-sm-inline mt-1 mt-sm-0">
                                <span class="op2">36,482 entries</span><span class="op2"> • </span><span class="op2">Updated <time datetime="1601047809000">19 hours ago</time></span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 my-lg-0 ml-lg-4">
                        <button type="button" class="btn btn-primary btn-sm ioe" >Add</button>
                    </div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-lg-flex" >
                    <div class="flex-grow-1">
                        <div class="notranslate koi" >Steven Black</div>
                        <div class="mt-1 m12" >
                            Extending and consolidating hosts files from several well-curated sources like adaway.org, mvps.org, malwaredomainlist.com, someonewhocares.org, and potentially others.
                        </div>
                        <div class="mt-1 m123" >
                            <div class="d-sm-inline">
                                <a target="_blank" rel="noopener noreferrer" href="https://github.com/StevenBlack/hosts" class="notranslate wordbreak" >github.com/StevenBlack/hosts</a>
                                <span class="d-none d-sm-inline op2" > • </span>
                            </div>
                            <div class="d-sm-inline mt-1 mt-sm-0">
                                <span class="op2">56,598 entries</span><span class="op2"> • </span><span class="op2">Updated <time datetime="1600657210000">5 days ago</time></span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 my-lg-0 ml-lg-4">
                        <button type="button" class="btn btn-primary btn-sm ioe" >Add</button>
                    </div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-lg-flex" >
                    <div class="flex-grow-1">
                        <div class="notranslate koi" >Disconnect (Tracking)</div>
                        <div class="mt-1 m12" >Free yourself from unwanted tracking. Enjoy a faster, safer internet.</div>
                        <div class="mt-1 m123" >
                            <div class="d-sm-inline">
                                <a target="_blank" rel="noopener noreferrer" href="https://disconnect.me" class="notranslate wordbreak" >disconnect.me</a><span class="d-none d-sm-inline op2" > • </span>
                            </div>
                            <div class="d-sm-inline mt-1 mt-sm-0">
                                <span class="op2">34 entries</span><span class="op2"> • </span><span class="op2">Updated <time datetime="1586487608000">6 months ago</time></span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 my-lg-0 ml-lg-4">
                        <button type="button" class="btn btn-primary btn-sm ioe">Add</button>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</div>

      
    </div>
  </div>


  <div class="modal fade" id="myModalsec" role="dialog">
    <div class="modal-dialog">
    
    <div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Add</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
    </div>
    <div class="p-0 modal-body">
        <div class="list-group list-group-flush">
            <div class="list-group-item hgroup" >
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/xiaomi.01c5deee.svg" alt="" class="width100"  /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12">Xiaomi</div>
                            <div class="m12">Phones &amp; Tablets, Smart TVs, Routers</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe">Add</button></div>
                </div>
            </div>
            <div class="list-group-item hgroup">
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/huawei.7323b50e.svg" alt=""  class="width100" /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12" >Huawei</div>
                            <div class="m12">Phones &amp; Tablets</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe" >Add</button></div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/samsung.1ec7ccd9.svg" alt=""  class="width100" /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12" >Samsung</div>
                            <div class="m12">Phones, Tablets, Smart TVs</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe" >Add</button></div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/alexa.658d4994.svg" alt=""  class="width100" /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12" >Amazon Alexa</div>
                            <div class="m12">Alexa-enabled devices</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe" >Add</button></div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/windows.6613fbcb.svg" alt=""  class="width100" /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12" >Windows</div>
                            <div class="m12">All versions</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe" >Add</button></div>
                </div>
            </div>
            <div class="list-group-item hgroup">
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/apple.6cd82816.svg" alt=""  class="width100" /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12" >Apple</div>
                            <div class="m12">iOS, macOS, tvOS</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe" >Add</button></div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/roku.c0aa656c.svg" alt=""  class="width100" /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12" >Roku</div>
                            <div class="m12">All Roku devices</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe" >Add</button></div>
                </div>
            </div>
            <div class="list-group-item hgroup" >
                <div class="d-flex">
                    <div class="d-flex align-items-center imgpopu" ><img src="/assets/images/sonos.4e516f3d.svg" alt=""  class="width100" /></div>
                    <div class="flex-grow-1">
                        <div>
                            <div class="notranslate n12" >Sonos</div>
                            <div  class="m12">Speakers</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-2 ml-4"><button type="button" class="btn btn-primary btn-sm ioe" >Add</button></div>
                </div>
            </div>
        </div>
    </div>
</div> 

      
    </div>
  </div>
            
            
            
            </>
  );
}

